// Paint: the ball turns pink and slows down
import { definePart } from '../core/registry';
import { rr, lg, shadowOn, shadowOff, C } from '../core/draw-helpers';
import type { Ctx2D } from '../core/types';

export function drawPaint(ctx: Ctx2D, x: number, y: number, sel?: boolean) {
  ctx.save(); ctx.translate(x, y);
  // puddle
  ctx.fillStyle = C.paint; ctx.globalAlpha = 0.85;
  ctx.beginPath(); ctx.ellipse(8, 14, 42, 12, 0, 0, 7); ctx.fill(); ctx.globalAlpha = 1;
  // tilted bucket
  ctx.rotate(-0.35);
  shadowOn(ctx, 8, 4);
  ctx.beginPath(); ctx.moveTo(-30, -24); ctx.lineTo(-4, -26); ctx.lineTo(0, 14); ctx.lineTo(-34, 16); ctx.closePath();
  ctx.fillStyle = lg(ctx, -26, 16, '#E7E4F2', '#A9A3C0'); ctx.fill(); shadowOff(ctx);
  ctx.fillStyle = C.paint; ctx.beginPath(); ctx.ellipse(-16, -25, 14, 4, 0, 0, 7); ctx.fill();
  ctx.strokeStyle = '#8B84A0'; ctx.lineWidth = 2.5; ctx.beginPath(); ctx.arc(-17, -24, 16, Math.PI * 1.05, Math.PI * 1.95); ctx.stroke();
  ctx.restore();
  if (sel) { ctx.save(); rr(ctx, x - 44, y - 32, 88, 64, 14); ctx.strokeStyle = '#fff'; ctx.lineWidth = 4; ctx.setLineDash([8, 6]); ctx.stroke(); ctx.restore(); }
}

export const paint = definePart({
  rects: [{ x: 0, y: 0, w: 80, h: 56 }], rot: false, sensor: true, paint: true, thumb: false,
  draw: (ctx, pl, sel) => drawPaint(ctx, pl.x, pl.y, sel),
  icon: ctx => drawPaint(ctx, 0, 0),
  intro(x, t, g, { fakeBall }) {
    drawPaint(x, 200, 214);
    const k = t / 200;
    let bx = 20 + Math.min(k, 0.3) / 0.3 * 170, painted = false;
    if (k > 0.3) { painted = true; bx = 190 + (1 - Math.pow(1 - Math.min(1, (k - 0.3) / 0.7), 3)) * 160; }
    g.ball(x, fakeBall(bx, 222, painted ? 1 : 8, 0, 18, painted), 'hero', t);
    // speed lines
    x.strokeStyle = 'rgba(59,42,92,.35)'; x.lineWidth = 4; x.lineCap = 'round';
    const n = painted ? 1 : 3;
    for (let i = 0; i < n; i++) { x.beginPath(); x.moveTo(bx - 30 - i * 10, 212 + i * 8); x.lineTo(bx - 50 - i * 16, 212 + i * 8); x.stroke(); }
  },
});
